export default __webpack_public_path__ + "static/media/cu.f089e3b8.svg";